export enum OptimizelySystemFeatureFlags {
    CLEAR_CACHE_ON_FLAGS_CHANGE = 'clear_cache_on_flags_change',
    PURGE_ALL_CACHE_TRIGGER = 'purge_all_cache_trigger',
    PURGE_CACHE_BY_AMPLIENCE_TEST_FLAG = 'purge_cache_by_amplience_test_flag',
    PURGE_CACHE_BY_URL_TEST_FLAG = 'purge_cache_by_url_test_flag',
    API_VERSION_3_ENABLED = 'api_version_3_enabled',
    USE_OPTIMIZELY_REACT_SDK = 'use_optimizely_react_sdk',
    MEMBER_API_VERSION_3_ENABLED = 'member_api_version_3_enabled',
}
